/* eslint-disable no-undef */
import React, { useContext } from 'react';
import LocaleContext from 'constants/localization';

import { alternatingBackGround } from 'helpers/styleHelpers';

import Form from 'react-bootstrap/Form';
import FieldEdit from 'field/edit/FieldEdit';

const DefaultModal = ({ resource }) => {
  const LS = useContext(LocaleContext);
  const fields = Object.values(resource.fields);

  if (fields.length < 1) {
    return (
      <label>{LS.error.noValues}</label>
    );
  }

  return (
    <div>
      <Form validated={resource.validated} ref={resource.ref}>
        {
          fields.map((field, key) => (
            <div key={key} style={alternatingBackGround(key)}>
              <FieldEdit field={field} />
            </div>
          ))
        }
      </Form>
    </div>
  );
};

export default DefaultModal;